import { string } from 'prop-types';
import { and, shape } from 'airbnb-prop-types';

import { cmsPageShape } from '@common/types/cms';

export const giftCardsPageDataShape = and([
  cmsPageShape,
  shape({
    cardImage: shape({
      meta: shape({
        downloadUrl: string,
      }),
      title: string,
    }),
  }),
]);
